<template>
  <div class="upload-img">
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.error}}</span>
        </alart-msg>
        <modal class="select-gallery" :display="modal" @modalStatus="closeModal()" >
            <h1>所有內容圖</h1>
            <div class="content">
                <div class="left">
                    <img v-if="files.length > 0" :src="files[selected].blob" alt="">
                    <div class="edit-btn">
                        <file-upload
                        class="replace"
                        post-action="/upload/post"
                        input-id="replace"
                        :size="1024 * 5"
                        :maximum="1"
                        :value="replaceFile"
                        @input="replaceGallery"
                        @input-file="inputFile"
                        @input-filter="inputFilter"
                        ref="uploadReplace">
                            <img class="upload-icon" src="@/assets/img/icon/gallery.svg" alt="">
                            取代照片
                        </file-upload>
                        <div @click.prevent="galleryRemove(files[selected])" class="delete">
                            <img src="@/assets/img/icon/trash.svg" alt="">
                            刪除照片
                        </div>
                    </div>
                </div>
                <div class="right">
                    <ul>
                        <li v-for="(file, index) in files" :key="{index, compnentKey}" :class="{'active': selected == index}" @click="selected = index">
                            <img :src="file.blob" alt="">
                        </li>
                        <li class="list-upload" v-show="files.length < 10" :class="{'drop-active': $refs.upload && $refs.upload.dropActive}">
                            <file-upload
                            class="upload-btn"
                            post-action="/upload/post"
                            :size="1024 * 5"
                            :maximum="10"
                            :multiple="true"
                            :drop="true"
                            :drop-directory="true"
                            v-model="files"
                            @input-file="inputFile"
                            @input-filter="inputFilter"
                            ref="upload">
                                <img class="upload-icon" src="@/assets/img/icon/upload.svg" alt="">
                            </file-upload>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button" @click="closeModal()">確認</button>
            </div>
        </modal>
        <!-- <div @click="uploadImage">上傳圖片</div> -->
        <div class="image-cover">
            <div class="title">封面縮圖</div>
            <div v-if="cover.length == 0" class="cover-block" :class="{'error': imgError}">
                <file-upload
                class="upload-btn"
                post-action="/upload/post"
                input-id="cover"
                :size="1024 * 5"
                :maximum="1"
                :multiple="true"
                v-model="cover"
                @input-file="inputFile"
                @input-filter="inputFilter"
                ref="uploadCover">
                    <img class="upload-icon" src="@/assets/img/icon/upload.svg" alt="">
                    上傳圖片
                </file-upload>
                <span v-show="imgCoverError" class="error">必填欄位</span>
            </div>
            <div v-else class="cover-preview">
                <div  class="preview">
                    <img  :src="cover[0].blob" />
                </div>
                <file-upload
                    class="replace"
                    post-action="/upload/post"
                    input-id="cover"
                    :size="1024 * 5"
                    :maximum="1"
                    :multiple="true"
                    :drop="true"
                    :drop-directory="true"
                    v-model="cover"
                    @input-file="inputFile"
                    @input-filter="inputFilter"
                    ref="uploadCover">
                        取代圖片
                </file-upload>
            </div>
        </div>
        <div class="image-content">
            <div class="title">
                內容圖
                <span v-show="imgError" class="error">至少上傳一張內容圖</span>
            </div>
            <div  v-if="files.length" class="has-img">
                <ul>
                    <li v-for="(file, index) in files" :key="index"  @mouseenter="fullScreenShow(index)" @mouseleave="fullScreenHide(index)">
                        <div v-show="hover[index]" :key="componentKey" @click="openGallery(index)" class="full-screen">
                            <img src="@/assets/img/icon/fullscreen.svg" alt="">
                        </div>
                        <div class="preview">
                            <img  :src="file.blob" />
                        </div>
                        <img class="cancel" @click.prevent="$refs.upload.remove(file)" src="@/assets/img/icon/cancel_black.svg" alt="">
                        <span v-if="file.error">{{file.error}}</span>
                    </li>
                    <li class="list-upload" v-show="files.length < 10" :class="{'drop-active': $refs.upload && $refs.upload.dropActive}">
                        <file-upload
                        class="upload-btn"
                        post-action="/upload/post"
                        :size="1024 * 5"
                        :maximum="10"
                        :multiple="true"
                        :drop="true"
                        :drop-directory="true"
                        v-model="files"
                        @input-file="inputFile"
                        @input-filter="inputFilter"
                        ref="upload">
                            <img class="upload-icon" src="@/assets/img/icon/upload.svg" alt="">
                            <span class="upload-description">拖放檔案或點擊此區立即上傳</span>
                            <span class="upload-drop-alarm">將圖片拖放到這裡</span>
                        </file-upload>
                    </li>
                </ul>
            </div>
            <div v-else class="no-img" :class="{'drop-active': $refs.upload && $refs.upload.dropActive, 'error': imgError}">
                <!-- <button class="upload-btn">上傳圖片</button> -->
                <file-upload
                class="upload-area"
                post-action="/upload/post"
                :maximum="10"
                :multiple="true"
                :drop="true"
                :drop-directory="true"
                v-model="files"
                @input-file="inputFile"
                @input-filter="inputFilter"
                ref="upload">
                    <img class="upload-icon" src="@/assets/img/icon/upload.svg" alt="">
                    <span class="upload-description">拖放檔案或點擊此區立即上傳</span>
                    <span class="upload-drop-alarm">將圖片拖放到這裡</span>
                </file-upload>
            </div>
        </div>
         
  </div>
</template>
<script>
import FileUpload from 'vue-upload-component';
import Modal from '@/components/widge/Modal.vue';
import ImgCheckbox from '@/components/widge/ImgCheckbox.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';

export default {
    data() {
        return {
        componentKey: 0,
        hover: [],
        cover: [],
        files: [],
        replaceFile: [],
        fileTmp: [],
        selected: 0,
        // selectTemp: null,
        modal: false,
        alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                error: null,
            },
        }
    },
    props: {
        imgError: Boolean,
        imgCoverError: Boolean,
    },
    watch: {
        files: {
            handler: function (val) {
                for (let i = 0; i < val.length; i++) {
                    this.hover[i] = false
                }
                this.$store.dispatch('setImageFiles', val)
            },
            deep: true
        },
        cover: function (val) {
            this.$store.dispatch('setCover', val)
        }
    },
    methods: {
        fullScreenShow: function (index) {
            this.hover[index] = true
            this.componentKey += 1
        },
        fullScreenHide: function (index) {
            this.hover[index] = false
            this.componentKey += 1
        },
        openGallery: function (index) {
            this.modal = true
            this.selected = index
        },
        galleryRemove: function (file) {
            this.$refs.upload.remove(file)
            if(this.selected == 0){
                this.selected = 0
            }else{
                this.selected -= 1
            }
        },
        replaceGallery: function (file) {
            // this.fileTmp = this.files[this.selected]
            this.files[this.selected] = file[0]
            this.componentKey += 1
        },
        closeModal: function (type) {
            this.modal = false
        },
        inputFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                if (newFile.xhr) {
                //  Get the response status code
                // console.log('status', newFile.xhr.status)
                }
            }
        },
        inputFilter: function (newFile, oldFile, prevent) {
                console.log('response', newFile)
        
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
                    this.alart.fail = true
                    this.msg.error = '請上傳JPG或PNG檔案'
                    return prevent()
                }

                if(newFile.size > (1024*1024*5)){
                    this.alart.fail = true
                    this.msg.error = '檔案最大限制5MB'
                    return prevent()
                }
            }
            // console.log(newFile)
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
    },
    components: {
        FileUpload,
        Modal,
        ImgCheckbox,
        AlartMsg,
    },
}
</script>
<style lang="scss" scoped>
    .upload-img{
        position: relative;
        margin-bottom: 40px;
        .title{
            position: relative;
            margin-bottom: 12px;
            .error{
                top: unset;
            }
        }
        .image-cover{
            margin-bottom: 30px;
            .cover-block{
                position: relative;
                width: 124px;
                height: 93px;
                border-radius: 4px;
                border: dashed 1px #cacfcd;
                background-color: #ffffff;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                img{
                    width: 15px;
                    margin-bottom: 8px;
                }
                .upload-btn{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                }
                .error{
                    position: absolute;
                    width: 200px;
                    left: 136px;
                    top: unset;
                }
            }
            .cover-block.error{
                border: dashed 1px #fc7171;
            }
            .cover-preview{
                display: flex;
                align-items: center;
                .preview{
                    width: 124px;
                    height: 93px;
                    display: flex;
                    margin-right: 16px;
                    align-items: center;
                    border-radius: 4px;
                    overflow: hidden;
                    >img{
                        width: 100%;
                    }
                }
                .replace{
                    width: 104px;
                    height: 44px;
                    border-radius: 4px;
                    border: solid 1px #e0dfde;
                    background: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
        .no-img.error{
            border: dashed 1px #fc7171;
        }
        .no-img{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 1154px;
            height: 166px;
            margin-bottom: 30px;
            border-radius: 2px;
            border: dashed 1px #cacfcd;
            background-color: #ffffff;
            box-sizing: border-box;
            .upload-area{
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                .upload-icon{
                    margin-bottom: 20px;
                }
            }
            .upload-warm{
                margin-top: 10px;
                color: #a8a5a4;
            }
            .upload-drop-alarm{
                display: none;
            }
        }
        .no-img.drop-active{
            border: solid 1px #ff9275;
            background-color: #fff4f1;
            .upload-btn,
            .upload-icon,
            .upload-description,
            .upload-warm{
                display: none;
            }
            .upload-drop-alarm{
                display: block;
                font-weight: 500;
                color: #ff9275;
            }
        }
        .has-img{
            ul{
                display: flex;
                flex-wrap: wrap;
                li{
                    position: relative;
                    margin-right: 17px;
                    margin-bottom: 13px;
                    cursor: pointer;
                    .full-screen{
                        position: absolute;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        height: 100%;
                        border-radius: 4px;
                        background-color: rgba(32, 35, 34, 0.8);
                    }
                    .preview{
                        width: 124px;
                        height: 93px;
                        display: flex;
                        align-items: center;
                        border-radius: 4px;
                        overflow: hidden;
                        >img{
                            width: 100%;
                        }
                    }
                    .cancel{
                        position: absolute;
                        cursor: pointer;
                        top: -14px;
                        right: -14px;
                    }
                    
                }
                li:nth-child(8n){
                    margin-right: 0px;
                }
                .list-upload{
                    width: 264px;
                    height: 93px;
                    border-radius: 4px;
                    border: dashed 1px #cacfcd;
                    background-color: #ffffff;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    img{
                        width: 15px;
                        margin-bottom: 8px;
                    }
                    .upload-btn{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                    }
                    .upload-drop-alarm{
                        display: none;
                    }
                }
                .list-upload.drop-active{
                    border: solid 1px #ff9275;
                    background-color: #fff4f1;
                    .upload-icon,
                    .upload-description,
                    .upload-warm{
                        display: none;
                    }
                    .upload-drop-alarm{
                        display: block;
                        font-weight: 500;
                        color: #ff9275;
                    }
                    
                }
            }
        }
        .select-gallery{
            .modal-content{
                width: 742px;
                height: 600px;
                padding: 0 !important;
                .detail{
                    align-items: flex-start !important;
                    h1{
                        margin: 32px auto;
                    }
                    .content{
                        padding: 0 32px;
                        overflow-x: hidden;
                        display: flex;
                        margin-bottom: 15px;
                        .left{
                            position: relative;
                            width: 540px;
                            height: 405px;
                            margin-right: 12px;
                            display: flex;
                            align-items: center;
                            border-radius: 4px;
                            overflow: hidden;
                            >img{
                                width: 100%;
                            }
                            .edit-btn{
                                position: absolute;
                                display: flex;
                                bottom: 20px;
                                left: 20px;
                                .replace,
                                .delete{
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    width: 130px;
                                    height: 54px;
                                    border-radius: 4px;
                                    background: #fff;
                                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                                    margin-right: 20px;
                                    img{
                                        margin-right: 4px;
                                    }
                                }
                            }
                        }
                        .right{
                            ul{
                                display: flex;
                                flex-direction: column;
                                height: 405px;
                                width: 100px;
                                flex-wrap: wrap;
                                li{
                                    width: 53px;
                                    height: 40px;
                                    display: flex;
                                    align-items: center;
                                    margin-bottom: 10px;
                                    border-radius: 1px;
                                    overflow: hidden;
                                    box-sizing: border-box;
                                    margin-right: 10px;
                                    >img{
                                        width: 100%;
                                    }
                                }
                                li.active{
                                    border: solid 2px #ff9275;
                                }
                                li.list-upload{
                                    border-radius: 4px;
                                    border: dashed 1px #cacfcd;
                                    background-color: #ffffff;
                                    display: flex;
                                    flex-direction: column;
                                    align-items: center;
                                    justify-content: center;
                                    img{
                                        width: 15px;
                                    }
                                }
                            }
                        }
                    }
                    .content::-webkit-scrollbar {
                        display: none;
                    }
                }
                
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1280px) {
        .upload-img{
            .no-img{
                width: 1142px;
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/landlord/houseStatus/houseManagement/addHouse/uploadImg.vue